import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { UtilsService } from 'src/core/services/utils.service';

export interface SnackBarData{
  message: string;
  action: string;
  type: string;
  showDetails: boolean;
}

@Component({
    selector: 'app-error-alert',
    templateUrl: './error-alert.component.html',
    styleUrls: ['./error-alert.component.scss'],
    standalone: false
})
export class ErrorAlertComponent implements OnInit {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData,
    private snackBarRef: MatSnackBarRef<ErrorAlertComponent>,
    private _utilService: UtilsService
  ) { }

  ngOnInit(): void {
  }

  dismiss(){
    this.snackBarRef.dismiss();
  }

  showDetails() {
    this._utilService.openErrorSheet();
  }

}
